import Component from './TikTokAnalyticsPublic.vue'
export default Component
